export default {
  teams: {
    manager: "MANAGER",
    operation: "OPERATION",
    sales: "SALES",
    salesManager: "SALES_MANAGER",
    warehouse: "WAREHOUSE",
    external: "EXTERNAL",
    admin: "ADMIN",
    production: "PRODUCTION",
    purchasing: "PURCHASING",
    china: "CHINA",
  },
};
